import { z } from '../zod';

export const AiPageResetStatusResponseValidationSchema = z.object({
  canReset: z.boolean().meta({
    description:
      'False while the page has any payment, booking, subscription or submission (live or test), or a checkout draft saved in the last 30 minutes.',
  }),
});

export const AiPageResetResponseValidationSchema = z.object({
  pageId: z.string(),
  type: z.enum(['checkout', 'event', 'form']),
});

export type AiPageResetStatusResponse = z.infer<typeof AiPageResetStatusResponseValidationSchema>;
export type AiPageResetResponse = z.infer<typeof AiPageResetResponseValidationSchema>;
